export default __webpack_public_path__ + "static/media/bgCardNoBorder.d36cdd7a.png";